/**
 * usePostScope — the office constraint every `posts` query must carry. (RW-2957)
 *
 * Given a surface's `user` (App.js puts `postViewer` on it), returns
 *   ready  false while the viewer's users doc is still loading — don't query yet
 *   scope  null (sees every office: query unconstrained) or the values for
 *          `where('office', 'in', scope)`
 *   key    a stable string for effect deps — the users doc re-emits on every
 *          profile write, and a new viewer object must not re-run a listener
 *          whose constraint did not change (Rule 25: each re-run re-reads).
 */
import { useMemo } from 'react';
import { postViewerFor, postOfficeScope, postScopeKey } from '../lib/postAudience';

export default function usePostScope(user) {
  const viewer = postViewerFor(user);
  const key = postScopeKey(viewer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const scope = useMemo(() => postOfficeScope(viewer), [key]);
  return { ready: !!viewer, scope, key };
}
